/* eslint-disable */
import * as THREE from 'three'
import r from './r1.js'
import a from './deep4.js'
import { i402, i403 } from './h.js'

var s = function () {
  function t(e) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, t),
      this.id = "BackgroundUnderWater-Particles",
      this.initParticlesAmmount = e.initParticles,
      this.transitionParticlesAmmount = e.transitionParticles,
      this.ammount = this.initParticlesAmmount + this.transitionParticlesAmmount,
      this.speedH = e.speedH,
      this.speedV = e.speedV,
      this.size = e.size,
      this.sizeModifier = window.isDesktop ? 2 : 1,
      this.type = e.type,
      this.texture = e.texture,
      this.positions = [],
      this.initPositionX = [],
      this.randomSpeed = [],
      this.randomNegSpeed = [],
      this.type = [],
      this.maxZ = 5,
      this.smoothScrollRatio = 0,
      this.scrollRatio = 0,
      this.update = this.update.bind(this),
      this.setScrollActive = this.setScrollActive.bind(this),
      this.setScrollUnactive = this.setScrollUnactive.bind(this),
      this.initParticles()
  }
  return r(t, [{
    key: "initParticles",
    value: function () {
      for (var e = 0; e < this.ammount; e++)
        this.positions.push(5 * (2 * Math.random() - 1)),
          this.positions.push(10 * (2 * Math.random() - 1)),
          this.positions.push((2 * Math.random() - 1) * this.maxZ),
          this.randomSpeed.push(Math.random()),
          this.randomNegSpeed.push(Math.random() - Math.random()),
          this.type.push(e < this.initParticlesAmmount ? 1 : 0);
      this.uniforms = (0,
        a.default)("points"),
        this.uniforms.map.value = this.texture,
        this.uniforms.time = {
          value: 0
        },
        this.uniforms.size.value = this.size * window.devicePixelRatio * this.sizeModifier,
        this.uniforms.opacity.value = .5,
        this.uniforms.speedH = {
          value: this.speedH
        },
        this.uniforms.speedV = {
          value: this.speedV
        },
        this.uniforms.transitionOpacity = {
          value: 0
        },
        this.uniforms.resolution = {
          value: new THREE.Vector2
        };
      var t = new THREE.ShaderMaterial({
        vertexShader: i402,
        fragmentShader: i403,
        uniforms: this.uniforms,
        defines: {
          USE_MAP: !0,
          USE_SIZEATTENUATION: !0
        },
        fog: !0,
        depthTest: !0,
        transparent: !0
      })
        , n = new THREE.BufferGeometry;
      n.addAttribute("position", new THREE.Float32BufferAttribute(this.positions, 3)),
        n.addAttribute("initPositionX", new THREE.Float32BufferAttribute(this.initPositionX, 1)),
        n.addAttribute("randomSpeed", new THREE.Float32BufferAttribute(this.randomSpeed, 1)),
        n.addAttribute("randomNegSpeed", new THREE.Float32BufferAttribute(this.randomNegSpeed, 1)),
        n.addAttribute("type", new THREE.Float32BufferAttribute(this.type, 1)),
        this.particles = new THREE.Points(n, t)
    }
  }, {
    key: "show",
    value: function () {
      TweenMax.to(this.uniforms.transitionOpacity, 1, {
        value: 1
      })
    }
  }, {
    key: "hide",
    value: function () {
      TweenMax.to(this.uniforms.transitionOpacity, 1, {
        value: 0
      })
    }
  }, {
    key: "getParticles",
    value: function () {
      return this.particles
    }
  }, {
    key: "update",
    value: function (e) {
      this.uniforms.time.value += .02,
        this.scrollActive && (this.scrollRatio = window.currentScrollTop / this.containerHeight * 17,
          this.smoothScrollRatio += 1 * (this.scrollRatio - this.smoothScrollRatio),
          this.uniforms.speedV.value = this.scrollRatio)
    }
  }, {
    key: "setScrollActive",
    value: function (e) {
      this.scrollActive = !0,
        this.containerHeight = e
    }
  }, {
    key: "setScrollUnactive",
    value: function () {
      this.scrollActive = !1
    }
  }, {
    key: "dispose",
    value: function () {
      TweenMax.killTweensOf(this.uniforms.transitionOpacity),
        this.particles.material.dispose(),
        this.particles.geometry.dispose(),
        this.particles = null,
        this.initParticlesAmmount = null,
        this.transitionParticlesAmmount = null,
        this.ammount = null,
        this.speedH = null,
        this.speedV = null,
        this.size = null,
        this.sizeModifier = null,
        this.type = null,
        this.texture = null,
        this.positions = null,
        this.initPositionX = null,
        this.randomSpeed = null,
        this.randomNegSpeed = null,
        this.type = null,
        this.maxZ = null,
        this.smoothScrollRatio = null,
        this.scrollRatio = null
    }
  }]),
    t
}();
var t = { default: s }

export default t
